import { generateRandomId } from "../../../utils/session";
import AUTOMATION_BLOCK_TYPES from "./AutomationBlockTypes";

export const ActionPalette = [
    {
        group: "Interactions",
        enabled: true,
        items: [
            {
                name: "Fallback",
                id: AUTOMATION_BLOCK_TYPES.FALLBACK,
            },
            {
                name: "Timeout",
                id: AUTOMATION_BLOCK_TYPES.TIMEOUT,
            },
            { name: "Filter", id: AUTOMATION_BLOCK_TYPES.FILTER },
            { name: "Flow", id: AUTOMATION_BLOCK_TYPES.FLOW },
            { id: AUTOMATION_BLOCK_TYPES.SLEEP },
            { id: AUTOMATION_BLOCK_TYPES.WAIT_FOR },
            { id: AUTOMATION_BLOCK_TYPES.NOOP },
            { id: AUTOMATION_BLOCK_TYPES.CATCH_WEBHOOK, disabled: true },
            { id: AUTOMATION_BLOCK_TYPES.TERMINATE_AUTOMATION },
            { id: AUTOMATION_BLOCK_TYPES.SHOW_WIDGET },
            { id: AUTOMATION_BLOCK_TYPES.ASK_AI },
            { id: AUTOMATION_BLOCK_TYPES.FIND_CHATS, disabled: true },
            { id: AUTOMATION_BLOCK_TYPES.FIND_CHAT, disabled: true },
        ],
    },
    {
        group: "Contact Actions",
        enabled: true,
        items: [
            { id: AUTOMATION_BLOCK_TYPES.CREATE_CONTACT },
            { id: AUTOMATION_BLOCK_TYPES.UPDATE_CONTACT },
            { id: AUTOMATION_BLOCK_TYPES.FIND_CONTACTS },
            { id: AUTOMATION_BLOCK_TYPES.FIND_CONTACT },
            { id: AUTOMATION_BLOCK_TYPES.ASSIGN_OWNER },
        ],
    },
    {
        group: "Loop Actions",
        enabled: true,
        items: [
            { name: "Loop", id: AUTOMATION_BLOCK_TYPES.LOOP },
            { name: "Loop Next", id: AUTOMATION_BLOCK_TYPES.LOOP_NEXT },
            { name: "Loop Break", id: AUTOMATION_BLOCK_TYPES.LOOP_BREAK },
            { name: "Loop Continue", id: AUTOMATION_BLOCK_TYPES.LOOP_CONTINUE },
            { name: "Loop Finish", id: AUTOMATION_BLOCK_TYPES.LOOP_FINISH },
        ],
    },
    {
        group: "Data Formatters",
        enabled: true,
        items: [
            { name: "String Formatter", id: AUTOMATION_BLOCK_TYPES.STRING_FORMAT },
            { name: "Number Formatter", id: AUTOMATION_BLOCK_TYPES.NUMBER_FORMAT },
            { name: "Date Formatter", id: AUTOMATION_BLOCK_TYPES.DATE_FORMAT },
        ],
    },
    {
        group: "File Actions",
        enabled: true,
        items: [{ name: "CSV Records", id: AUTOMATION_BLOCK_TYPES.RECORDS_FROM_CSV }],
    },
    {
        group: "Cache Actions",
        enabled: true,
        items: [
            { name: "Cache Write", id: AUTOMATION_BLOCK_TYPES.CACHE_WRITE },
            { name: "Cache Read", id: AUTOMATION_BLOCK_TYPES.CACHE_READ },
            { name: "Cache Extend", id: AUTOMATION_BLOCK_TYPES.CACHE_EXTEND },
            { name: "Cache Delete", id: AUTOMATION_BLOCK_TYPES.CACHE_DELETE },
        ],
    },
    {
        group: "Table Actions",
        enabled: true,
        items: [
            { name: "Create Record", id: AUTOMATION_BLOCK_TYPES.TABLE_CREATE_RECORD },
            { name: "Delete Record", id: AUTOMATION_BLOCK_TYPES.TABLE_DELETE_RECORD },
            { name: "Update Record", id: AUTOMATION_BLOCK_TYPES.TABLE_UPDATE_RECORD },
            { name: "Find Record", id: AUTOMATION_BLOCK_TYPES.TABLE_FIND_RECORD },
            { name: "Find Records", id: AUTOMATION_BLOCK_TYPES.TABLE_FIND_RECORDS },
        ],
    },
    {
        group: "Zoho Actions",
        enabled: true,
        items: [
            { name: "Find Records By Phone", id: AUTOMATION_BLOCK_TYPES.ZOHO_FIND_RECORDS_BY_PHONE },
            { name: "Add Attachment To Record", id: AUTOMATION_BLOCK_TYPES.ZOHO_ADD_ATTACHMENT_TO_RECORD },
            { name: "Upload Image To Field", id: AUTOMATION_BLOCK_TYPES.ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD },
            { name: "Create Record", id: AUTOMATION_BLOCK_TYPES.ZOHO_CREATE_RECORD },
        ],
    },
    {
        group: "YouTube Actions",
        enabled: true,
        items: [
            { name: "Reply Comment", id: AUTOMATION_BLOCK_TYPES.YOUTUBE_REPLY_COMMENT },
            { name: "Update Comment Status", id: AUTOMATION_BLOCK_TYPES.YOUTUBE_UPDATE_COMMENT_STATUS },
            { name: "Set Moderation Status", id: AUTOMATION_BLOCK_TYPES.YOUTUBE_SET_MODERATION_STATUS },
        ],
    },
    {
        group: "Google Business Actions",
        enabled: true,
        items: [
            { name: "Reply Review", id: AUTOMATION_BLOCK_TYPES.GOOGLE_BUSINESS_REPLY_REVIEW },
            { name: "Update Review Status", id: AUTOMATION_BLOCK_TYPES.GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS },
        ],
    },
    {
        group: "Google Play Actions",
        enabled: true,
        items: [
            { name: "Reply Review", id: AUTOMATION_BLOCK_TYPES.GOOGLE_PLAY_REPLY_REVIEW },
            { name: "Update Review Status", id: AUTOMATION_BLOCK_TYPES.GOOGLE_PLAY_UPDATE_REVIEW_STATUS },
        ],
    },
    {
        group: "App Store Actions",
        enabled: true,
        items: [
            { name: "Reply Review", id: AUTOMATION_BLOCK_TYPES.APP_STORE_REPLY_REVIEW },
            { name: "Update Review Status", id: AUTOMATION_BLOCK_TYPES.APP_STORE_UPDATE_REVIEW_STATUS },
            { name: "Delete Review Response", id: AUTOMATION_BLOCK_TYPES.APP_STORE_DELETE_REVIEW_RESPONSE },
        ],
    },
    {
        group: "Actions",
        enabled: true,
        items: [
            { name: "Go To Step", id: AUTOMATION_BLOCK_TYPES.GO_TO_STEP },
            //{ name: "Add To Segment", id: AUTOMATION_BLOCK_TYPES.ADD_TO_SEGMENT },
            //{ name: "Remove From Segment", id: AUTOMATION_BLOCK_TYPES.REMOVE_FROM_SEGMENT },
            {
                name: "Webhook",
                id: AUTOMATION_BLOCK_TYPES.WEBHOOK,
            },
            {
                name: "Send JSON Response",
                id: AUTOMATION_BLOCK_TYPES.SEND_JSON_RESPONSE,
            },
            {
                name: "Run JavaScript",
                id: AUTOMATION_BLOCK_TYPES.RUN_JAVASCRIPT,
            },
            {
                name: "Send CAPI Event",
                id: AUTOMATION_BLOCK_TYPES.META_SEND_CAPI_EVENT,
            },
            //{ name: "Set Attribute", id: AUTOMATION_BLOCK_TYPES.SET_ATTRIBUTE },
        ],
    },
    {
        group: "Supsis Actions",
        enabled: true,
        items: [
            {
                group: "Ticket Actions",
                items: [
                    { name: "Create Ticket", id: AUTOMATION_BLOCK_TYPES.CREATE_TICKET },
                    { name: "Update Ticket", id: AUTOMATION_BLOCK_TYPES.TICKET_UPDATE },
                ],
            },
            {
                group: "Task Actions",
                items: [
                    { name: "Create Task", id: AUTOMATION_BLOCK_TYPES.CREATE_TASK },
                    { name: "Update Task", id: AUTOMATION_BLOCK_TYPES.UPDATE_TASK },
                ],
            },
            {
                group: "Messaging Actions",
                items: [
                    {
                        name: "Transfer Chat",
                        id: AUTOMATION_BLOCK_TYPES.TRANSFER_CHAT,
                        disabled: true,
                    },
                    {
                        name: "Forward to ChatBot",
                        id: AUTOMATION_BLOCK_TYPES.TRANSFER_TO_CHATBOT,
                        disabled: true,
                    },
                    {
                        name: "Send SMS",
                        id: AUTOMATION_BLOCK_TYPES.SEND_SMS,
                    },
                    {
                        name: "Send Mail",
                        id: AUTOMATION_BLOCK_TYPES.SEND_MAIL,
                    },
                    {
                        name: "Send Whatsapp Business Message",
                        id: AUTOMATION_BLOCK_TYPES.SEND_WP_BUSINESS_MESSAGE,
                    },
                    {
                        name: "Reply Trendyol Question",
                        id: AUTOMATION_BLOCK_TYPES.REPLY_TRENDYOL_QUESTION,
                    },
                    {
                        name: "AI Call",
                        id: AUTOMATION_BLOCK_TYPES.AI_CALL,
                    },
                ],
            },
            {
                group: "Calendar Actions",
                items: [
                    { name: "Create Event", id: AUTOMATION_BLOCK_TYPES.CREATE_EVENT },
                    { name: "Create Reservation", id: AUTOMATION_BLOCK_TYPES.CREATE_RESERVATION },
                ],
            },
            { name: "Get Record", id: AUTOMATION_BLOCK_TYPES.GET_SUPSIS_RECORD_BY_ID },
            { name: "Set Department", id: AUTOMATION_BLOCK_TYPES.SET_DEPARTMENT, disabled: true },
            {
                name: "Ban Visitor",
                id: AUTOMATION_BLOCK_TYPES.SUPPRESSION_ADD,
                disabled: true,
            },
            {
                name: "Unban Visitor",
                id: AUTOMATION_BLOCK_TYPES.SUPPRESSION_REMOVE,
            },
        ],
    },
];

export const BlockStyles = {
    SHOW_WIDGET: { color: "#ffffff", backgroundColor: "#06a9f3" },
    ZOHO_FIND_RECORDS_BY_PHONE: { color: "#ffffff", backgroundColor: "#4959DA" },
    ZOHO_ADD_ATTACHMENT_TO_RECORD: { color: "#ffffff", backgroundColor: "#4959DA" },
    ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: { color: "#ffffff", backgroundColor: "#4959DA" },
    ZOHO_CREATE_RECORD: { color: "#ffffff", backgroundColor: "#4959DA" },
    META_SEND_CAPI_EVENT: { color: "#ffffff", backgroundColor: "#674ea7" },
    
    CACHE_WRITE: { color: "#ffffff", backgroundColor: "#1976d2" },
    CACHE_READ: { color: "#ffffff", backgroundColor: "#0288d1" },
    CACHE_EXTEND: { color: "#ffffff", backgroundColor: "#0097a7" },
    CACHE_DELETE: { color: "#ffffff", backgroundColor: "#d32f2f" },

    START_POINT: { color: "#fff", backgroundColor: "#566e8a" },
    AI_ASSISTANT: { color: "#fff", background: "linear-gradient(162deg,#4b6ae5,#0031f6)" },
    DEFAULT_FALLBACK: { color: "#fff", backgroundColor: "#797b8c" },
    DEFAULT_TIMEOUT: { color: "#fff", backgroundColor: "#d2ba69" },
    AI_CALL: { color: "#fff", backgroundColor: "rgb(35 35 35 / 84%)" },

    BOT_RESPONSE: { color: "#647283", backgroundColor: "#f5f5f5" },
    AI_BOT_RESPONSE: { color: "#647283", backgroundColor: "#41ce13" },
    AI_CLASSIFICATION: { color: "#647283", backgroundColor: "#41ce13" },
    FALLBACK: { color: "#ffffff", backgroundColor: "#797b8c" },
    TIMEOUT: { color: "#fff", backgroundColor: "#d2ba69" },
    FILTER: { color: "#fff", backgroundColor: "#686ad3" },
    FLOW: { color: "#000", backgroundColor: "#b3d6ff" },
    ATTACHMENT_INPUT: { color: "#647283", backgroundColor: "#E7E4E4" },
    USER_INPUT: { color: "#59687b", backgroundColor: "#c9d3de" },
    GO_TO_STEP: { color: "#000", backgroundColor: "#ffdc67" },
    ADD_TO_SEGMENT: { color: "#22314A", backgroundColor: "#9CCB80" },
    REMOVE_FROM_SEGMENT: { color: "#22314A", backgroundColor: "#F5F5F5" },
    WEBHOOK: { color: "#fff", backgroundColor: "#40455b" },
    SEND_JSON_RESPONSE: { color: "#fff", backgroundColor: "#40455b" },
    RUN_JAVASCRIPT: { color: "#fff", backgroundColor: "#40455b" },
    SET_ATTRIBUTE: { color: "#fff", backgroundColor: "#AD6FE9" },
    TICKET_UPDATE: { color: "#fff", backgroundColor: "#AD6FE9" },
    QUESTION: { color: "#000", backgroundColor: "#ffad5c" },
    CLOSE_CHAT: { color: "#000", backgroundColor: "#f5f5f5" },
    CREATE_TICKET: { color: "#ffffff", backgroundColor: "#AD6FE9" },
    TRANSFER_TO_CHATBOT: { color: "#ffffff", backgroundColor: "#ff00ca" },
    TRANSFER_CHAT: { color: "#000", backgroundColor: "#76E394" },
    TAG_CHAT: { color: "#000", backgroundColor: "#EDED67" },
    REMOVE_TAG: { color: "#000", backgroundColor: "#EDED67" },
    SET_DEPARTMENT: { color: "#000", backgroundColor: "#40e6ba" },
    SEND_TRANSCRIPT: { color: "#ffffff", backgroundColor: "#4959DA" },
    SEND_SMS: { color: "#ffffff", backgroundColor: "#4ee82f" },
    CREATE_TASK: { color: "#fff", backgroundColor: "#73adc5" },
    UPDATE_TASK: { color: "#fff", backgroundColor: "#73adc5" },
    SUPPRESSION_ADD: { color: "#fff", backgroundColor: "#9d2126" },
    SUPPRESSION_REMOVE: { color: "#fff", backgroundColor: "#9d2126" },

    GET_LOCATION: { color: "#000", backgroundColor: "#7aa8e0" },
    SUCCESS: { color: "#00C800", backgroundColor: "#fff" },
    FAILURE: { color: "#FF0000", backgroundColor: "#fff" },
    SEND_MAIL: { color: "#ffffff", backgroundColor: "#4ee82f" },
    CREATE_EVENT: { color: "#ffffff", backgroundColor: "#033c7c" },
    CREATE_RESERVATION: { color: "#ffffff", backgroundColor: "#033c7c" },
    RESERVATION_SELECT_TIME: { color: "#ffffff", backgroundColor: "#235603" },
    RESERVATION_SELECT_DAY: { color: "#ffffff", backgroundColor: "#235603" },
    RESERVATION_OPEN_URL: { color: "#ffffff", backgroundColor: "#235603" },
    RESERVATION_EVENT_LIST: { color: "#ffffff", backgroundColor: "#235603" },

    SEND_WP_BUSINESS_MESSAGE: { color: "#fff", backgroundColor: "#4ee82f" },
    INSTAGRAM_COMMENT_REPLY: { color: "#fff", backgroundColor: "#833AB4" },
    INSTAGRAM_COMMENT_DELETE: { color: "#fff", backgroundColor: "#833AB4" },
    INSTAGRAM_COMMENT_SHOW: { color: "#fff", backgroundColor: "#833AB4" },
    INSTAGRAM_COMMENT_HIDE: { color: "#fff", backgroundColor: "#833AB4" },
    INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: { color: "#fff", backgroundColor: "#833AB4" },
    AI_MENU_FLOW: { color: "#fff", backgroundColor: "#4ee82f" },

    LOOP: { color: "#ffffff", backgroundColor: "#ff00ca" },
    LOOP_NEXT: { color: "#ffffff", backgroundColor: "#ff00ca" },
    LOOP_BREAK: { color: "#ffffff", backgroundColor: "#ff00ca" },
    LOOP_CONTINUE: { color: "#ffffff", backgroundColor: "#ff00ca" },
    LOOP_FINISH: { color: "#ffffff", backgroundColor: "#ff00ca" },

    REPLY_TRENDYOL_QUESTION: { color: "#ffffff", backgroundColor: "#4ee82f" },

    SLEEP: { color: "#ffffff", backgroundColor: "#06a9f3" },
    NOOP: { color: "#ffffff", backgroundColor: "#73adc5" },
    CATCH_WEBHOOK: { color: "#ffffff", backgroundColor: "#6e5b8c" },
    TERMINATE_AUTOMATION: { color: "#ffffff", backgroundColor: "#9d2126" },
    CREATE_CONTACT: { color: "#ffffff", backgroundColor: "#ff7a1f" },
    UPDATE_CONTACT: { color: "#ffffff", backgroundColor: "#ff7a1f" },
    FIND_CONTACTS: { color: "#ffffff", backgroundColor: "#ff7a1f" },
    FIND_CONTACT: { color: "#ffffff", backgroundColor: "#ff7a1f" },
    FIND_CHATS: { color: "#ffffff", backgroundColor: "#833AB4" },
    FIND_CHAT: { color: "#ffffff", backgroundColor: "#833AB4" },
    WAIT_FOR: { color: "#ffffff", backgroundColor: "#06a9f3" },
    STRING_FORMAT: { color: "#ffffff", backgroundColor: "#40455b" },
    NUMBER_FORMAT: { color: "#ffffff", backgroundColor: "#40455b" },
    DATE_FORMAT: { color: "#ffffff", backgroundColor: "#40455b" },
    RECORDS_FROM_CSV: { color: "#ffffff", backgroundColor: "#235603" },
    MESSAGE_RECEIVED: { color: "#ffffff", backgroundColor: "#ff7a1f" },
    TABLE_CREATE_RECORD: { color: "#ffffff", backgroundColor: "#4959DA" },
    TABLE_DELETE_RECORD: { color: "#ffffff", backgroundColor: "#4959DA" },
    TABLE_UPDATE_RECORD: { color: "#ffffff", backgroundColor: "#4959DA" },
    TABLE_FIND_RECORD: { color: "#ffffff", backgroundColor: "#4959DA" },
    TABLE_FIND_RECORDS: { color: "#ffffff", backgroundColor: "#4959DA" },
    ASSIGN_OWNER: { color: "#ffffff", backgroundColor: "#ff7a1f" },

    YOUTUBE_REPLY_COMMENT: { color: "#ffffff", backgroundColor: "#FF0000" }, // YouTube kırmızısı
    YOUTUBE_UPDATE_COMMENT_STATUS: { color: "#ffffff", backgroundColor: "#FF0000" }, // YouTube kırmızısı
    YOUTUBE_SET_MODERATION_STATUS: { color: "#ffffff", backgroundColor: "#FF0000" }, // YouTube kırmızısı

    GOOGLE_BUSINESS_REPLY_REVIEW: { color: "#ffffff", backgroundColor: "#4285F4" }, // Google mavisi
    GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: { color: "#ffffff", backgroundColor: "#4285F4" }, // Google mavisi

    GOOGLE_PLAY_REPLY_REVIEW: { color: "#ffffff", backgroundColor: "#01875f" }, // Google Play yeşili
    GOOGLE_PLAY_UPDATE_REVIEW_STATUS: { color: "#ffffff", backgroundColor: "#01875f" }, // Google Play yeşili

    APP_STORE_REPLY_REVIEW: { color: "#ffffff", backgroundColor: "#007aff" }, // Apple mavisi
    APP_STORE_UPDATE_REVIEW_STATUS: { color: "#ffffff", backgroundColor: "#007aff" }, // Apple mavisi
    APP_STORE_DELETE_REVIEW_RESPONSE: { color: "#ffffff", backgroundColor: "#007aff" }, // Apple mavisi
};

export const Payloads = {
    GO_TO_STEP: {
        default: {
            blockId: null,
        },
    },
};
